import { SamplePlayerKeys } from './constants';
import * as D from './deps';

export function getShouldResumeTrack(state) {
  return state.sample.get(SamplePlayerKeys.SHOULD_RESUME_TRACK);
}

export function getNowPlayingSampleSrc(state) {
  return state.sample.get(D.Constants.AudioPlayer.AudioPlayerKeys.SRC);
}

export function isSamplePlaying(state) {
  return state.sample.get(D.Constants.AudioPlayer.AudioPlayerKeys.PLAYING);
}

export function isNowPlayingSample(state, src) {
  return getNowPlayingSampleSrc(state) === src;
}

export function getNowPlayingSample(state) {
  return D.AudioUtils.AudioPlayback.get(getNowPlayingSampleSrc(state));
}

export const externalUtils = {
  isNowPlayingSample,
};
